import { useEffect, useState } from "react";

/**
 * A live "current time" that advances on an interval, so any UI deriving status
 * from `now` (e.g. the Med Pass grid's due→overdue transitions and the "Now"
 * cursor) stays in sync with the clock while the screen is open — instead of
 * freezing at mount.
 *
 * Returns a `Date` that updates every `intervalMs` (default 30s) and clears its
 * timer on unmount. Consumers that need determinism in tests should keep passing
 * an explicit `now` into the pure helpers (`deriveAdminStatus(admin, now)`);
 * this hook only drives the live screen.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
